"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDnd = require("react-dnd");
var _SourceListUtils = require("./SourceListUtils");
var _SourceListItem = require("./SourceListItem.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SourceListItemDnd = function SourceListItemDnd(_ref) {
  var children = _ref.children,
    source = _ref.source,
    index = _ref.index,
    onReorderSources = _ref.onReorderSources,
    dataTestId = _ref.dataTestId,
    onDragSource = _ref.onDragSource;
  var ref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOver = _useState2[0],
    setIsOver = _useState2[1];
  var useDragProps = (0, _SourceListUtils.getUseDragSourceProps)(source, index);
  var _useDrag = (0, _reactDnd.useDrag)(useDragProps),
    _useDrag2 = (0, _slicedToArray2["default"])(_useDrag, 2),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1];
  (0, _react.useEffect)(function () {
    onDragSource(isDragging);
  }, [isDragging, onDragSource]);
  var useDropProps = (0, _SourceListUtils.getUseDropProps)(onReorderSources, ref, index, source);
  var _useDrop = (0, _reactDnd.useDrop)(_objectSpread(_objectSpread({}, useDropProps), {}, {
      onDragOver: function onDragOver() {
        setIsOver(true);
      },
      onDragLeave: function onDragLeave() {
        setIsOver(false);
      },
      onDrop: function onDrop() {
        setIsOver(false);
      }
    })),
    _useDrop2 = (0, _slicedToArray2["default"])(_useDrop, 2),
    result = _useDrop2[0],
    drop = _useDrop2[1];
  (0, _react.useEffect)(function () {
    setIsOver(result.isOver);
  }, [result.isOver]);
  drag(drop(ref));
  var dropStyles = _objectSpread({}, isDragging && {
    cursor: 'move'
  });
  return _react["default"].createElement(_SourceListItem.SourceListItemWrapper, {
    "data-testid": dataTestId,
    ref: ref,
    style: dropStyles,
    $isV2: true
  }, children, isOver && _react["default"].createElement(_SourceListItem.DropPlaceholder, null, _react["default"].createElement(_SourceListItem.DropPlaceholderText, null, "Drop source here")));
};
SourceListItemDnd.propTypes = {
  children: _propTypes["default"].node,
  index: _propTypes["default"].number,
  source: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    type: _propTypes["default"].string
  }),
  onReorderSources: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  onDragSource: _propTypes["default"].func
};
var _default = exports["default"] = (0, _react.memo)(SourceListItemDnd);